export default __webpack_public_path__ + "static/media/waiting-start.f2947967.png";